import globalization, { commonNs } from './index';
import NamespaceManager from './namespaceManager';

let vueNsManager = new NamespaceManager();

Object.assign(vueNsManager, {
    addVm(vm) {
        let { ns, translationResourcesLoaded } = vm.$options.i18next;
        if (!ns && !translationResourcesLoaded) {
            return;
        }
        vueNsManager.addNamespace(vm, ns);
        let startNs = [...commonNs];
        if (ns) {
            startNs = startNs.concat(ns);
        }
        return globalization.loadNs(startNs).then(_ => {
            vm.langKey.id = Date.now();
            translationResourcesLoaded?.call(vm);
        });
    },
    removeVm(vm) {
        vueNsManager.removeNamespace(vm);
    },
    languageChangedCallback() {
        vueNsManager.keys.map(vm => {
            vm.langKey.id = Date.now();
            vm.$options.i18next.translationResourcesLoaded?.call(vm);
        });
    }
});

globalization.registerNamespaceManager(vueNsManager);

function install(Vue) {
    Vue.mixin({
        i18next: {
            // If using an array ， Different namespaces will have the problem of overriding attributes with the same name 
            ns: ''
        },
        beforeCreate() {
            this.langKey = Vue.observable({ id: 0 });
            vueNsManager.addVm(this);
        },
        beforeDestory() {
            vueNsManager.removeVm(this);
        },
        methods: {
            $t(key, ...args) {
                if (!key) {
                    return;
                }
                this.langKey.id;
                const nsKey = key.split(':');
                if (nsKey.length > 1) {
                    //key with namespace 
                    return globalization.$t(key, ...args);
                }
                return globalization.$st(
                    this.$options.i18next.ns,
                    key,
                    ...args
                );
            },
            /**
             *
             * @param { Namespaces ， string or array } ns
             * @param  {key( Cannot have a namespace  ), options} args
             * @returns
             */
            $st(ns, key, ...args) {
                return globalization.$st(ns, key, ...args);
            },
            /**
             *  wait ns Internationalized resources loaded 
             * @returns Promise
             */
            waitForLangNs() {
                let { ns } = this.$options.i18next;
                return globalization.loadNs(ns);
            },
            waitForLangNsWithCatch() {
                let { ns } = this.$options.i18next;

                return globalization.loadNs(ns).catch(err => {
                    console.error(`waitForLangNsWithCatch : ${ns}`, err);
                });
            }
        }
    });
}

export default install;
